import { defineMessages } from "react-intl";

export const messages = defineMessages({
  dependsOn: {
    id: "b1Toj3",
    defaultMessage: "Requires: {deps}",
    description: "pipeline step dependency label",
  },
  moreFields: {
    id: "1pwjwc",
    defaultMessage: "+{count} more",
    description: "number of additional fields not shown",
  },
  downloadTemplate: {
    id: "2PuV33",
    defaultMessage: "Download Template",
    description: "download template button in pipeline chain",
  },
  importButton: {
    id: "Rh8J4L",
    defaultMessage: "Import",
    description: "open import modal button in pipeline chain",
  },
  scanDescription: {
    id: "43MM+/",
    defaultMessage:
      "Scans the import folder, auto-classifies images as shared or variant-specific by filename, and downloads a pre-filled sheet.",
    description: "description of the scan images button",
  },
  scanButton: {
    id: "2WwTjq",
    defaultMessage: "Scan Folder & Generate Sheet",
    description: "scan import folder and download pre-filled images sheet",
  },
  bundledInVariants: {
    id: "U2Gx6u",
    defaultMessage: "Included in the Variants import — no separate import needed.",
    description: "info label for variant_channel_listings info-only node",
  },
});
